import React, { useContext, useState } from 'react';
import { AuthContext } from '../AuthContext';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../assets/CSS/Dashboard.css'; // Same as used in RedProcess

export default function ApprovalFormsPage() {
  const { user } = useContext(AuthContext);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const canAccess =
    user?.Auth === 'Admin' ||
    user?.Auth === 'Supervisor' ||
    (user?.Auth === 'SuperAdmin'); // && !['33', '34', '35', '36', '10'].includes(user?.EmployeeID)
    

  if (!canAccess) {
    return (
      <div className="d-flex dashboard">
        <div className={isSidebarVisible ? 'sidebar-container' : 'sidebar-hidden'}>
          <Sidebar />
        </div>
        <div className="flex-grow-1">
          <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
          <main className="main-container p-4">
            <h2>Access Denied</h2>
            <p>You do not have permission to view this page.</p>
          </main>
        </div>
      </div>
    );
  }

  const links = [
    { label: 'AI Form Assistant', url: '/ai-form-assistant' },
    { label: 'Expense Approval', url: '/expense-form-upload' },
    { label: 'Purchase Approval', url: 'https://forms.office.com/r/wqadRSHzLd' },
    { label: 'Leave Request', url: 'https://forms.office.com/r/M61HLYdCtc' },
    { label: 'Workers Advance', url: '/worker-advance-management' },
    { label: 'Miscellaneous', url: '/paid-to' },
    { label: 'Job Card Payment Cash', url: '/job-card-cash' },
    { label: 'Debit Note', url: '/debit-note' },
    {
      label: 'Loading & Unloading & Transportation',
      url: 'https://forms.office.com/r/6BAhFEQUbf',
    },
    { label: 'staff advance', url: 'https://forms.office.com/r/7rc1i9kUEs' },
    { label: 'KPI Related Issue', url: 'https://forms.office.com/r/nssHF5Bq9t' },
    { label: 'BOM Change Request', url: 'https://forms.office.com/r/1VSm6SUS9D' },
    { label: 'Extra Consumption/Wages', url: 'https://forms.office.com/pages/responsepage.aspx?id=Qw4GjBE1DUu9tYhQb6G7Y5xhHPOMeTBCr1nsbXPtxH9URUlXM0lQN1ZVMjM5SUtNRTBJRzYyRFRXNy4u&route=shorturl' },
    { label: 'Rate Approvel', url: 'https://forms.office.com/pages/responsepage.aspx?id=Qw4GjBE1DUu9tYhQb6G7Y5xhHPOMeTBCr1nsbXPtxH9UMFdJUjc3MDc1NFMzNkRFWUFNSDVaM1ZWMC4u&route=shorturl' },
    { label: 'Process Rate Change', url: 'https://forms.cloud.microsoft/r/tskLC6g2aW' },
    { label: 'Pagar Book', url: 'https://forms.office.com/r/gpcw8qJ0zC' },
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? 'sidebar-container' : 'sidebar-hidden'}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          <div className="container">
            <h1 className="mb-4">All Forms</h1>
            <div className="row g-3">
              {links.map(({ label, url }) => (
                <div key={label} className="col-12 col-md-6 col-lg-4">
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary w-100"
                  >
                    {label}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
